<template>
  <div class="child-Page">
    <childNav
      :routerName="$t('breadcrumbItem.house')"
      :backFlag="true"
      :versionFlag="true"
    ></childNav>
    <div class="main-contain">
      <div class="left-choose">
        <Card
          v-for="(item, index) in cardStrList"
          :key="index"
          class="card-box"
        >
          <div class="card-header" v-if="item.itemList.length > 0">
            <div
              class="divider"
              :class="{
                blueBtnBack: index === 0,
                yellowBtnBack: index === 1,
                greenBtnBack: index === 2,
              }"
            ></div>
            <span class="title">{{ item.title }}</span>
          </div>
          <div class="card-body" v-if="index === 0 || index === 1">
            <div v-for="(i, k) in item.itemList" :key="k">
              <Button
                :id="'deBtn' + k"
                :title="i.name"
                :type="
                  index === 0 ? 'primary' : index === 1 ? 'warning' : 'success'
                "
                size="large"
                draggable="true"
                class="btn-item"
                @dragstart.native="dragStart($event, index, k)"
                @dragend.native="dragEndHandle($event)"
                @mousedown.native="mouseClick($event)"
                >{{ i.smName }}</Button
              >
            </div>
          </div>

          <div class="card-body" v-if="index === 2">
            <div v-for="(t, p) in item.itemList" :key="p">
              <Button
                :type="
                  index === 0 ? 'primary' : index === 1 ? 'warning' : 'success'
                "
                :title="t.name"
                size="large"
                class="btn-item"
                @click="vineClick(p)"
                >{{ t.name }}</Button
              >
            </div>
          </div>
          <div class="card-header header-space control-box" v-if="index === 3">
            <div class="control-title">
              <div
                class="divider"
                :class="{
                  redBtnBack: index === 3,
                }"
              ></div>
              <span class="title">{{ item.title }}</span>
            </div>
            <RadioGroup v-model="indList.IndependentControl">
              <Radio
                v-for="(item, index) in item.singleList"
                :label="item.value"
                :key="index"
                size="large"
              >
                <span>{{ item.label }}</span>
              </Radio>
            </RadioGroup>
          </div>

          <div class="card-header control-box" v-if="index === 4">
            <div class="control-title">
              <div
                class="divider"
                :class="{
                  infoBtnBack: index === 4,
                }"
              ></div>
              <span class="title">{{ item.title }}</span>
            </div>
            <Button
              type="info"
              size="large"
              class="info-btn"
              :title="$t('house.controlBtn')"
              @click="openControl"
            >
              {{ $t("house.controlBtn") }}
            </Button>
          </div>
        </Card>
      </div>
      <div class="right-choose">
        <div class="room-page" v-if="showLayout">
          <!-- 户型图展示 -->
          <div class="room-box">
            <div class="title-span primary-color">
              <span>{{ $t("house.houseTitle") }}</span>
            </div>
            <div class="btn-list">
              <Tooltip
                :content="i.name"
                placement="top"
                theme="light"
                max-width="200"
                v-for="(i, k) in roomDataList"
                :key="k"
              >
                <Badge>
                  <Button
                    :type="btnFlag[k] ? 'primary' : 'default'"
                    size="large"
                    class="room-btn"
                    @click="changePic(k)"
                  >
                    {{ i.name }}
                  </Button>
                  <Icon
                    slot="count"
                    type="md-remove-circle"
                    class="close-badge"
                    @click="delImg(i, k)"
                  />
                </Badge>
              </Tooltip>
            </div>
            <div class="pic-box">
              <div
                class="new-right-pic"
                id="div1"
                @dragover="allowDropHandle($event)"
                @drop="dropHandle($event)"
              >
                <Ohyeah ref="scroller">
                  <img
                    :src="currentPic.url"
                    alt="pic"
                    id="backPic"
                    draggable="false"
                  />
                </Ohyeah>
              </div>
            </div>
            <div class="bottom-btn">
              <form id="uploadImg">
                <div class="form-box">
                  <Button
                    size="large"
                    icon="md-images"
                    type="info"
                    class="btn-margin file"
                    >{{ $t("house.upload") }}
                    <input
                      type="file"
                      name="facePic"
                      accept=".jpg,.jpeg"
                      @change="showPic($event)"
                      multiple
                  /></Button>
                </div>
              </form>

              <Button
                size="large"
                icon="ios-cloud-download-outline"
                type="success"
                class="btn-margin"
                @click="finishSetting"
                >{{ $t("house.download") }}</Button
              >
            </div>
          </div>
          <!-- 设备参数表 -->
          <devInfo
            :iconInfo="iconObj"
            :roomList="roomDataList"
            @getIconObj="updateIconInfo($event)"
            @getVineObj="updateVineInfo($event)"
            @delItem="delIconObj($event)"
          ></devInfo>
        </div>
        <div class="room-page" v-if="!showLayout">
          <noRoomLayout
            @getList="getPicList($event)"
            @sendReList="getReList(arguments)"
          ></noRoomLayout>
        </div>
      </div>
    </div>
    <div class="content_win">
      <importModal
        ref="importModal"
        @getList="getImportPic($event)"
        @resetList="resetInList()"
      ></importModal>
      <threeControlModal
        ref="threeControlModal"
        @getControl="getControlList($event)"
      ></threeControlModal>
    </div>
  </div>
</template>

<script>
import childNav from "@/components/homeNav/childNav.vue";
import noRoomLayout from "./noRoomLayout.vue";
import devInfo from "./devInfo.vue";
import importModal from "./importModal";
import { Ohyeah } from "vue-ohyeah-scroll";
import threeControlModal from "./threeControlModal.vue";
export default {
  name: "openList",
  components: {
    childNav,
    Ohyeah,
    noRoomLayout,
    devInfo,
    importModal,
    threeControlModal,
  },
  data() {
    return {
      url: require("@/assets/image/testPic/sdfa.jpg"),
      pageX: 0, // 底图相对整个html的位置x
      pageY: 0, // 底图相对整个html的位置y

      testData: new Array(100).fill(""),
      dragged: null,
      cardStrList: JSON.parse(JSON.stringify(this.global.cardStrList)),
      vineList: JSON.parse(JSON.stringify(this.global.vineList)), // 温控设置的数据内容
      picList: JSON.parse(JSON.stringify(this.global.iconShowList)),
      devNameList: JSON.parse(JSON.stringify(this.global.devNameList)),
      indList: {
        body: "ControlModeOfScene",
        IndependentControl: 0,
      }, // 独立设置的数据内容
      clickIndex: null, // 点击按钮的序号  0开始
      clickType: null, // 设备0  场景1
      sceneBtnIndex: 0, // 当前图标序号 场景
      clickAgainId: null, //   已在户型图中图标再次移动 图标的id
      dataList: [], // 用户设置的数据内容
      roomDataList: [], // 户型图设置的数据内容
      getHouseList: [],
      currentPic: {},
      btnFlag: [],
      showLayout: false,
      clickTop: 0, // 按钮点击偏移
      clickleft: 0,
      iconObj: {
        coord: [],
      }, // 图标信息传入信息编辑框
      picCurrIndex: null, // 当前选中的户型图序号
      clickFlag: false, // 点击再次移动偏移
      clickMoveTop: 0,
      clickMoveleft: 0,

      controlInfoList: [], // 三恒系统配置
    };
  },
  watch: {
    roomDataList: {
      handler() {
        if (!this.roomDataList.length > 0) {
          // 无户型图
          this.showLayout = false;
        } else {
          // 有户型图
          this.showLayout = true;
        }
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开当前路由的时候被调用，this可以被访问到
    this.$Notice.close("notice");
    next();
  },
  mounted() {
    if (!this.roomDataList.length > 0) {
      this.showLayout = false;
    } else {
      this.showLayout = true;
    }

    this.startNotice();
  },
  methods: {
    // 进入页面侧边提示使用chrome浏览器
    startNotice() {
      let that = this;
      let url = this.$common.handleUrl();

      this.$Notice.info({
        name: "notice",
        title: this.$t("house.chromeTip"),
        render: function (createElement) {
          return createElement("a", {
            domProps: {
              innerHTML: that.$t("house.downTip"),
            },
            style: {
              color: "#0f75ff",
              fontSize: "14px",
            },
            //attrs里面的内容是src属性
            attrs: {
              href: url,
              target: "_blank",
            },
          });
        },
      });
    },
    // 1. 上传户型图逻辑
    getPicList(list) {
      this.getHouseList = [];
      this.getHouseList = list;
      if (this.getHouseList.length > 0) {
        this.picCurrIndex = 0;
      }

      this.getHouseList.map((item, index) => {
        let num = index + 1;
        let obj = {
          id: index,
          body: "RoomLayout" + num,
          name: item.fileName,
          visible: true,
          imgDiv: [],
        };

        this.roomDataList.push(obj);
      });

      // 户型图列表第一项默认展示
      this.currentPic = this.getHouseList[0];
      // 传入户型图数量
      let btnLength = this.getHouseList.length;
      // 根据选择的户型图数量 显示同样数量的切换按钮
      this.btnFlag = this.global.btnFlag.slice(0, btnLength);
    },
    // 2. 编辑界面拖动逻辑
    // 点击按钮偏差保存
    mouseClick(e) {
      if (e.target.localName == "span") {
        let browser = this.$common.checkBrowser();

        if (
          browser === "Firefox" ||
          browser === "Edge" ||
          browser === "Chrome"
        ) {
          // 火狐 Edge 谷歌
          this.clickTop = e.offsetY / e.target.clientHeight;
          this.clickleft = e.offsetX / e.target.clientWidth;
        } else {
          this.clickTop = e.layerY / e.target.parentNode.clientHeight;
          this.clickleft = e.layerX / e.target.parentNode.clientWidth;
        }
      } else if (e.target.localName == "button") {
        this.clickTop = e.offsetY / e.target.clientHeight;
        this.clickleft = e.offsetX / e.target.clientWidth;
      }
    },
    // 拖动目标的拖动事件
    dragStart(ev, index, k) {
      // ev:为拖动元素

      if (this.roomDataList.length > 0) {
        ev.dataTransfer.effectAllowed = "copy";
        this.dragged = ev.target;

        this.clickIndex = k;
        this.clickType = index;
      } else {
        this.$Message.error(this.$t("house.dragTip"));
        this.dragged = null;
      }
    },
    //  完成元素拖动后触发，触发时没有进入目标元素
    dragEndHandle(ev) {
      this.dragged = null;
    },
    // 拖动目标在底图上拖动操作（只在底图内有效）
    allowDropHandle(ev) {
      ev.dataTransfer.dropEffect = "copy";

      // ev:为底图
      // 获取拖动目标(鼠标)就当前页面的x、y
      this.pageX = ev.pageX;
      this.pageY = ev.pageY;

      ev.preventDefault(); // @dragover 中一定要执行e.preventDefault()，否则@drop 事件不会触发
    },

    // 拖动结束后 添加新图标计算出坐标点 保存至数组 再次移动图标 更新数组
    dropHandle(ev) {
      //   获取户型图宽高

      let pic = document.getElementById("backPic");

      let maxWidth = pic.width - 60;
      let maxHeight = pic.height - 60;

      let addFlag = true;
      if (this.dragged) {
        addFlag = this.handleMaxLength();
      }

      if (!addFlag) {
        this.dragged = null;
        return false;
      }
      let targetRes = this.handleLocation(ev);
      let targetX = targetRes.targetX;
      let targetY = targetRes.targetY;

      if (
        Number(maxWidth) < Number(targetX) ||
        Number(maxHeight) < Number(targetY)
      ) {
        //   高度 宽度超过
        this.$Message.warning(this.$t("house.moveTip"));
        this.dragged = null;
        return false;
      }
      if (this.dragged) {
        // 添加新的图标
        // 命名

        let clIndex = this.clickIndex;
        let devNumber = Number(this.devNameList[clIndex].num);
        let devName = this.devNameList[clIndex].name;
        let devAllNameDNum = devName + devNumber;

        // 创建节点
        let tempNode = document.createElement("img");
        tempNode.classList.add("round-box");
        if (this.clickType === 0) {
          tempNode.setAttribute("id", devAllNameDNum);
          tempNode.setAttribute("src", this.picList[clIndex].iconList[0].pic);
        } else if (this.clickType === 1) {
          tempNode.setAttribute("id", "scene" + Number(this.clickIndex + 1));
          tempNode.setAttribute("src", this.picList[10].iconList[0].pic);
        }
        tempNode.setAttribute("style", `left:${targetX}px;top:${targetY}px`);
        tempNode.setAttribute("draggable", true);
        //将监听的方法绑定到新增的元素上
        tempNode.addEventListener("mousedown", this.clickAgainHandle);
        tempNode.addEventListener("click", this.clickInfoEdit);
        // 因为使用了滚动条组件 底图img元素被其他div包裹
        // 通过id定位底图 向上获取父元素 将新添加的图标元素添加进子节点
        let pic = document.getElementById("backPic");
        let parent = pic.parentNode;
        parent.appendChild(tempNode);

        // 删除拖动事件
        this.dragged = null;
        // 添加的图标加入数组存储
        let ind1 = Number(this.clickType); // 设备、场景
        let ind2 = Number(clIndex); // 按钮的序列 10个设备 8个场景
        let obj = {
          on: true,
          visible: true,
          belong: this.roomDataList[this.picCurrIndex].body,
          belongId: this.roomDataList[this.picCurrIndex].id,
          type: ind1, // 什么类型
          itemNum: ind2, // 当前类型的序号
          coord: [targetX, targetY], // 坐标属性
        };
        if (ind1 === 0) {
          // 设备
          obj.body = devAllNameDNum;
          obj.id = devAllNameDNum;
          obj.name = this.cardStrList[ind1].itemList[ind2].name + devNumber;

          this.dataList.push(obj);
          this.devNameList[clIndex].num++;
        } else if (ind1 === 1) {
          //   场景
          let num = Number(this.clickIndex) + 1; //  当前图标序号 移入了第几个图标
          obj.body = "scene" + num;
          obj.id = "scene" + num;
          obj.name = this.cardStrList[ind1].itemList[ind2].name;
          obj.ind = this.clickIndex;
          this.dataList.push(obj);
          this.sceneBtnIndex++;
        }
      } else {
        //   移动已有图标

        let img = document.getElementById(this.clickAgainId);
        img.setAttribute(
          "style",
          `left:${targetX}px;top:${targetY}px;width:60px;height:60px`
        );

        this.dataList.map((item) => {
          if (item.id === this.clickAgainId) {
            item.coord = [targetX, targetY];
          }
        });
      }
    },
    // 换算当前屏幕的图标大小
    changeBackWidth(val, type) {
      let res1 = Number(type) * Number(val);
      let res = 0;
      if (Number(res1) > 0) {
        let smRes = res1 / 1920;
        res = this.$common.getRound(smRes, 0);
      }
      return res;
    },
    // 移动已有图标时 保存当前选择图标的id 方可修改当前图标坐标
    clickAgainHandle(ev) {
      this.clickFlag = true;
      this.clickMoveTop = ev.offsetY;
      this.clickMoveleft = ev.offsetX;
      this.clickAgainId = ev.target.id;
    },
    // 根据 滚动条+拖动位置+图标点击位置 计算出坐标值
    handleLocation(ev) {
      const scrollObj = this.$refs.scroller.getScrollInfo();

      let addScrollLeft = scrollObj.scrollLeft;
      let addScrollTop = scrollObj.scrollTop;
      // ev:为底图
      // 底图相对整个页面的x、y
      let offsetLeft = ev.currentTarget.offsetLeft;
      let offsetTop = ev.currentTarget.offsetTop;

      let clickValWidth = 0;
      let clickValHeight = 0;
      if (this.clickFlag) {
        // 再次移动 计算偏移
        clickValWidth = this.clickMoveleft;
        clickValHeight = this.clickMoveTop;
      } else {
        // 首次移动 计算偏移
        // 目标x、y（生成的节点相对底图的位置,50为拖动元素的高度/宽的一半）
        let screenWidth = window.screen.width; //乘以缩放比例为真实的像素
        let iconWidth = this.changeBackWidth(60, Number(screenWidth));

        clickValWidth = this.$common.getRound(this.clickleft * iconWidth, 0);
        clickValHeight = this.$common.getRound(this.clickTop * iconWidth, 0);
      }

      let targetX = this.pageX - offsetLeft - clickValWidth + addScrollLeft;
      targetX = targetX < 0 ? 0 : targetX;
      let targetY = this.pageY - offsetTop - clickValHeight + addScrollTop;
      targetY = targetY < 0 ? 0 : targetY;

      let res = {
        targetX: targetX,
        targetY: targetY,
      };
      return res;
    },
    // 拖动数量限制
    handleMaxLength() {
      let typeInd = Number(this.clickType); // 设备、场景
      let ind = Number(this.clickIndex); // 按钮的序列 10个设备 8个场景

      let devSize = 0;
      let devFlag = true;
      let sceneFlag = true;
      let allFlag = true;
      let houseList = this.dataList;

      if (houseList.length >= 64) {
        allFlag = false;
      } else {
        if (houseList.length > 0 && houseList.length < 64) {
          houseList.map((item) => {
            if (Number(typeInd) === 0 && Number(item.type) === 0) {
              // 设备
              if (Number(item.itemNum) === ind) {
                devSize = devSize + 1;
              }
            } else if (Number(typeInd) === 1 && Number(item.type) === 1) {
              // 场景
              if (Number(ind) === Number(item.ind)) {
                sceneFlag = false;
              }
            }
          });
        }
        // 灯光最大数量是添加32个，空调最大数量添加12个等，总数量不超过64个
        // 2个自定义设备、6款传感器各1个、8种场景各1个
        const devRules = {
          0: 32, // 灯光
          1: 12, // 空调
          2: 12, // 地暖
          3: 12, // 新风
          4: 16, // 开关插座
          5: 16, // 窗帘
          6: 16, // 热水器
          7: 10, // BGM
          8: 2, // 自定义设备
          9: 1, // 热水系统
        };
        if (devRules.hasOwnProperty(ind) && devSize >= devRules[ind]) {
          devFlag = false;
        }
      }

      // 判断条件反转：如果不满足 (devflag && sceneFlag && allFlag)
      if (!(devFlag && sceneFlag && allFlag)) {
        this.$Message.warning(this.$t("house.maxSizeTip"));
        this.dragged = null;
        return false;
      }

      // 正常流程：只有满足条件才会执行到这里
      return true;
    },

    // 3. 户型图切换-删除-选中
    //   切换户型图按钮
    changePic(e) {
      let lastIndex = this.picCurrIndex;
      let nextIndex = e;
      this.btnFlag = [];
      //   按钮选中状态切换
      for (let i = 0; i < 8; i++) {
        if (i === e) {
          this.btnFlag.push(true);
        } else {
          this.btnFlag.push(false);
        }
      }

      // 选中户型图图片展示
      this.currentPic = this.getHouseList[e];

      // 处理切换图片时dom元素切换及保存
      this.handleChangeFun(lastIndex);

      // 将之前选择的图标 重新渲染
      let pic = document.getElementById("backPic");
      let parentNode = pic.parentNode;
      if (this.roomDataList[nextIndex].imgDiv.length > 0) {
        //   已有元素
        // 添加元素节点
        let list = this.roomDataList[nextIndex].imgDiv;
        for (let i in list) {
          parentNode.appendChild(list[i]); // 后面添加元素
        }
      }

      // 更新当前选中户型图序号
      this.picCurrIndex = e;
      // 将右侧图标选中内容清空 避免编辑报错
      this.iconObj = {
        coord: [],
      };
    },
    // 删除户型图
    delImg(i, k) {
      this.$confirm(this.$t("house.delHouseTip"), this.$t("common.tip"), {
        confirmButtonText: this.$t("common.ensure"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning",
      })
        .then(() => {
          this.toDelImg(i, k);
        })
        .catch(() => {});
    },
    // 删除后 更新选中状态和排序
    toDelImg(i, k) {
      // 清空该户型图下的设备、场景的图标
      let id = i.id;
      for (let i = 0; i < this.dataList.length; i++) {
        if (id === this.dataList[i].belongId) {
          this.dataList.splice(i, 1);
          i--;
        } else if (id < this.dataList[i].belongId) {
          // 删除户型图之后的户型图中的设备 要进1
          this.dataList[i].belongId = this.dataList[i].belongId - 1;
        }
      }

      //   清空户型图中的图标dom
      let leng = this.roomDataList.length;
      let picIdx = this.picCurrIndex;
      let res = 100;
      let picRes = null;
      let picFlag = false;
      if (k === picIdx) {
        // 删除的是选中的户型图
        if (leng > 1) {
          if (k === 0) {
            // 选中的是开头
            res = k;
            picRes = k + 1;
          } else {
            // 结尾 中间
            res = k - 1;
            picRes = k - 1;
          }
        }
        // 将右侧图标选中内容清空 避免编辑报错
        this.iconObj = {
          coord: [],
        };
      } else {
        //   删除的不是选中的户型图
        if (k < picIdx) {
          res = picIdx - 1;
          picRes = picIdx;
          picFlag = true;
        } else if (k > picIdx) {
          picRes = picIdx;
          res = picIdx;
          picFlag = true;
        }
      }
      if (Number(res) >= 0 && Number(res) < 100) {
        this.delChange(res);
        this.delChangePic(picRes, picFlag);
      }

      //  清空户型图数组内容
      this.getHouseList.splice(k, 1);
      this.roomDataList.splice(k, 1);
      if (this.roomDataList.length < 1) {
        this.showLayout = false;
      }

      let list = [];

      this.roomDataList.map((i, y) => {
        let ind = y + 1;
        let obj = {
          body: "RoomLayout" + ind,
          id: y,
          imgDiv: i.imgDiv,
          name: i.name,
          visible: i.visible,
        };
        list.push(obj);
      });
      this.roomDataList = list;
    },

    // 删除户型图后切换图片
    delChangePic(e, picFlag) {
      // 选中户型图图片展示
      this.currentPic = this.getHouseList[e];

      if (!picFlag) {
        let pic = document.getElementById("backPic");
        let parentNode = pic.parentNode;

        let childNodes = parentNode.childNodes;
        let imgLength = Object.keys(childNodes).length;

        //   当前图标选择的清空
        if (imgLength > 0) {
          let nameList = [];
          for (let i in childNodes) {
            if (typeof childNodes[i] === "object") {
              if (i > 0) {
                nameList.push(i);
              }
            }
          }
          let nameLength = nameList.length;
          for (let i = nameLength; i > 0; i--) {
            parentNode.removeChild(childNodes[i]);
          }
        }
        // 将之前选择的图标 重新渲染
        if (this.roomDataList[e].imgDiv.length > 0) {
          //   已有元素
          // 添加元素节点
          let list = this.roomDataList[e].imgDiv;
          for (let i in list) {
            parentNode.appendChild(list[i]); // 后面添加元素
          }
        }
      }
    },
    // 删除户型图后切换选中
    delChange(e) {
      this.btnFlag = [];
      //   按钮选中状态切换
      for (let i = 0; i < 8; i++) {
        if (i === e) {
          this.btnFlag.push(true);
        } else {
          this.btnFlag.push(false);
        }
      }

      this.picCurrIndex = e;
    },
    // 4. 更新设备信息
    // 更新修改
    clickInfoEdit(e) {
      let clickId = e.target.id;

      this.iconObj = {};
      this.dataList.map((item) => {
        if (item.id === clickId) {
          this.iconObj = item;
        }
      });
    },

    // 更新 设备、场景 信息
    updateIconInfo(obj) {
      let changeToBelong = null;
      let changeObjId = null;
      let moveIndex = null;
      let newRoomName = null;

      let picDevBlue = this.picList[obj.itemNum].iconList[0].pic;
      let picDevGrey = this.picList[obj.itemNum].iconList[1].pic;
      let picSeBlue = this.picList[10].iconList[0].pic;
      let picSeGrey = this.picList[10].iconList[1].pic;
      let typeFlag = Number(obj.type) === 0 ? true : false; // true dev,false scene

      //   判断是否改变图标归属户型图
      if (obj.newBelongId !== null && obj.newBelongId !== undefined) {
        this.roomDataList.map((item, key) => {
          if (item.id === obj.newBelongId && item.name !== obj.belong) {
            //  有变化
            moveIndex = key;
            newRoomName = item.body;
            changeToBelong = item.id;
            changeObjId = document.getElementById(obj.id);
          }
        });

        let coordArr = obj.coord;
        // 修改户型图中的图标样式
        changeObjId.style.left = Number(coordArr[0]) + "px";
        changeObjId.style.top = Number(coordArr[1]) + "px";
        if (obj.on) {
          //   开启 蓝色
          changeObjId.setAttribute("src", typeFlag ? picDevBlue : picSeBlue);
        } else {
          //   关闭 灰色
          changeObjId.setAttribute("src", typeFlag ? picDevGrey : picSeGrey);
        }

        this.roomDataList[moveIndex].imgDiv.push(changeObjId);
        this.dataList.map((item) => {
          if (item.id === obj.id) {
            item.belongId = obj.newBelongId;
            item.belong = newRoomName;
            item.name = obj.name;
            item.visible = obj.visible;
            item.on = obj.on;
            changeObjId.remove();
            if (obj.coord && obj.coord.length > 0) {
              item.coord = obj.coord;
            }
          }
        });

        this.iconObj = {};
      } else {
        //   修改 dataList中的数据
        this.dataList.map((item) => {
          if (item.id === obj.id) {
            item.name = obj.name;
            item.visible = obj.visible;
            item.on = obj.on;
            if (obj.coord && obj.coord.length > 0) {
              item.coord = obj.coord;
            }
          }
        });
        // 修改户型图中的图标样式
        let img = document.getElementById(obj.id);
        let coordArr = obj.coord;
        img.style.left = Number(coordArr[0]) + "px";
        img.style.top = Number(coordArr[1]) + "px";
        if (obj.on) {
          //   开启 蓝色
          img.setAttribute("src", typeFlag ? picDevBlue : picSeBlue);
        } else {
          //   关闭 灰色
          img.setAttribute("src", typeFlag ? picDevGrey : picSeGrey);
        }
      }

      this.$Message.success(this.$t("house.editTip"));
    },
    // 更新 删除图标
    delIconObj(item) {
      this.dataList.map((i, k) => {
        if (i.id === item.id) {
          this.dataList.splice(k, 1);
          document.getElementById(i.id).remove();
        }
      });

      this.roomDataList[item.belongId].imgDiv.map((t, y) => {
        if (t.id === item.id) {
          this.roomDataList[item.belongId].imgDiv.splice(y, 1);
        }
      });

      this.iconObj = {};

      this.$Message.success(this.$t("house.delTip"));
    },
    // 传感器点击处理
    vineClick(p) {
      if (this.roomDataList.length > 0) {
        let item = this.vineList[p];

        this.iconObj = {};
        this.iconObj.id = item.id;
        this.iconObj.name = item.config;
        this.iconObj.body = item.body;
        this.iconObj.visible = item.visible;
        this.iconObj.visibleNum = item.visible === true ? 1 : 0;
        this.iconObj.type = 2;
        this.iconObj.itemNum = p;
      } else {
        this.$Message.error(this.$t("house.vineTip"));
      }
    },
    // 更新温控 信息
    updateVineInfo(obj) {
      this.vineList.map((item) => {
        if (item.id === obj.id) {
          item.config = obj.name;
          item.visible = obj.visible;
          item.type = obj.type;
          item.itemNum = obj.itemNum;
        }
      });

      this.$Message.success(this.$t("house.editTip"));
    },

    // 导出
    finishSetting() {
      let startTag = this.$common.getTab(16) + "<";
      let endTag = "\n" + this.$common.getTab(16) + "</";
      let endTag2 = ">" + "\n" + "\n";
      let start1 = "\n" + this.$common.getTab(32) + "<";
      let start2 = ">";
      let end1 = "</";
      let end2 = ">";

      //   户型图
      let roomStr = "";
      this.roomDataList.map((item, index) => {
        let ind = index + 1;
        let bodyStart = startTag + "RoomLayout" + ind + start2;
        let bodyEnd = endTag + "RoomLayout" + ind + endTag2;
        item.body = "RoomLayout" + ind;

        let nameStart = start1 + "Name" + start2;
        let nameEnd = end1 + "Name" + end2;

        let visibleStart = start1 + "Visible" + start2;
        let visibleEnd = end1 + "Visible" + end2;

        let visibleVal = item.visible ? "True" : "False";

        let res =
          bodyStart +
          nameStart +
          item.name +
          nameEnd +
          visibleStart +
          visibleVal +
          visibleEnd +
          bodyEnd;

        roomStr = roomStr.concat(res);
      });

      //   独立控制场景
      let indeStart = startTag + "ControlModeOfScene" + start2;
      let indeEnd = endTag + "ControlModeOfScene" + endTag2;

      let controlStart = start1 + "IndependentControl" + start2;
      let controlEnd = end1 + "IndependentControl" + end2;
      let indeFlag =
        Number(this.indList.IndependentControl) === 0 ? "False" : "True";
      let indepent = indeStart + controlStart + indeFlag + controlEnd + indeEnd;

      let devSetting = [];
      let sceneSetting = [];
      let devStr = "";
      let sceneStr = "";

      this.dataList.map((item) => {
        if (Number(item.type) === 0) {
          devSetting.push(item);
        } else if (Number(item.type) === 1) {
          sceneSetting.push(item);
        }
      });
      devSetting.sort(this.sortArray);

      //  场景
      let sceneLastName = null;
      let sceneLastInd = 1;
      let sceneInd = null;
      sceneSetting.map((item) => {
        let bodyName = item.body.replace(/[0-9]+/g, "");
        if (sceneLastName === null) {
          sceneLastName = bodyName;
          sceneInd = sceneLastInd;
        } else if (sceneLastName !== bodyName) {
          sceneInd = 1;
          sceneLastName = bodyName;
        } else {
          sceneInd = sceneInd + 1;
        }

        let bodyStart = startTag + bodyName + sceneInd + start2;
        let bodyEnd = endTag + bodyName + sceneInd + endTag2;

        let nameStart = start1 + "Name" + start2;
        let nameEnd = end1 + "Name" + end2;

        let onStart = start1 + "On" + start2;
        let onEnd = end1 + "On" + end2;

        let visibleStart = start1 + "Visible" + start2;
        let visibleEnd = end1 + "Visible" + end2;

        let belongStart = start1 + "Belong" + start2;
        let belongEnd = end1 + "Belong" + end2;

        let visibleVal = item.visible ? "True" : "False";
        let onVal = item.on ? "True" : "False";

        let indStart = start1 + "index" + start2;
        let indEnd = end1 + "index" + end2;

        let coord = [];
        coord = item.coord;
        let coordRes = coord.join(",");
        let coordStart = start1 + "coord" + start2;
        let coordEnd = end1 + "coord" + end2;

        // 重新通过belongId 获取当前户型图名称
        let currBelong = null;
        this.roomDataList.map((i) => {
          if (i.id === item.belongId) {
            currBelong = i.body;
          }
        });
        let res =
          bodyStart +
          nameStart +
          item.name +
          nameEnd +
          onStart +
          onVal +
          onEnd +
          visibleStart +
          visibleVal +
          visibleEnd +
          coordStart +
          coordRes +
          coordEnd +
          belongStart +
          currBelong +
          belongEnd +
          indStart +
          item.ind +
          indEnd +
          bodyEnd;

        sceneStr = sceneStr.concat(res);
      });
      let lastName = null;
      let lastInd = 1;
      let ind = null;
      //   设备
      devSetting.map((item) => {
        let bodyName = item.body.replace(/[0-9]+/g, "");

        if (lastName === null) {
          lastName = bodyName;
          ind = lastInd;
        } else if (lastName !== bodyName) {
          ind = 1;
          lastName = bodyName;
        } else {
          ind = ind + 1;
        }

        let bodyStart = startTag + bodyName + ind + start2;
        let bodyEnd = endTag + bodyName + ind + endTag2;

        let nameStart = start1 + "Name" + start2;
        let nameEnd = end1 + "Name" + end2;

        let onStart = start1 + "On" + start2;
        let onEnd = end1 + "On" + end2;
        let onVal = item.on ? "True" : "False";

        let visibleStart = start1 + "Visible" + start2;
        let visibleEnd = end1 + "Visible" + end2;

        let visibleVal = item.visible ? "True" : "False";

        let coord = [];
        coord = item.coord;

        let coordRes = coord.join(",");
        let coordStart = start1 + "coord" + start2;
        let coordEnd = end1 + "coord" + end2;

        let belongStart = start1 + "Belong" + start2;
        let belongEnd = end1 + "Belong" + end2;

        // 重新通过belongId 获取当前户型图名称
        let currBelong = null;
        this.roomDataList.map((i) => {
          if (i.id === item.belongId) {
            currBelong = i.body;
          }
        });
        let res =
          bodyStart +
          nameStart +
          item.name +
          nameEnd +
          onStart +
          onVal +
          onEnd +
          visibleStart +
          visibleVal +
          visibleEnd +
          coordStart +
          coordRes +
          coordEnd +
          belongStart +
          currBelong +
          belongEnd +
          bodyEnd;

        devStr = devStr.concat(res);
      });

      //  温控
      let vineStr = "";
      this.vineList.map((item) => {
        let bodyStart = startTag + item.body + start2;
        let bodyEnd = endTag + item.body + endTag2;

        let nameStart = start1 + "Name" + start2;
        let nameEnd = end1 + "Name" + end2;

        let visibleStart = start1 + "Visible" + start2;
        let visibleEnd = end1 + "Visible" + end2;
        let visibleVal = item.visible ? "True" : "False";

        let res =
          bodyStart +
          nameStart +
          item.config +
          nameEnd +
          visibleStart +
          visibleVal +
          visibleEnd +
          bodyEnd;

        vineStr = vineStr.concat(res);
      });

      // 三恒系统

      let controlStr = "";
      let threeConstant = "";
      let controlInd = 1;
      this.controlInfoList.map((item, index) => {
        let nameStart = start1 + "Name" + start2;
        let nameEnd = end1 + "Name" + end2;

        let onStart = start1 + "On" + start2;
        let onEnd = end1 + "On" + end2;

        let visibleStart = start1 + "Visible" + start2;
        let visibleEnd = end1 + "Visible" + end2;

        let visibleVal = item.visible ? "True" : "False";
        let onVal = item.on ? "True" : "False";

        let bodyStart = null;
        let bodyEnd = null;

        if (Number(item.type) === 1) {
          // 主控
          bodyStart = startTag + "Three constant master" + start2;
          bodyEnd = endTag + "Three constant master" + endTag2;
        } else if (Number(item.type) === 0) {
          //   分控

          bodyStart = startTag + "Three constant branch" + controlInd + start2;
          bodyEnd = endTag + "Three constant branch" + controlInd + endTag2;

          controlInd = controlInd + 1;
        }

        let res =
          bodyStart +
          nameStart +
          item.name +
          nameEnd +
          onStart +
          onVal +
          onEnd +
          visibleStart +
          visibleVal +
          visibleEnd +
          bodyEnd;

        controlStr = controlStr.concat(res);

        // 三恒主控配置内容
        if (Number(item.type) === 1 && item.visible) {
          item.configList.map((i, k) => {
            let vis = i.value === 1 ? "True" : "False";
            let result =
              startTag +
              i.key +
              start2 +
              nameStart +
              i.name +
              nameEnd +
              visibleStart +
              vis +
              visibleEnd +
              endTag +
              i.key +
              endTag2;

            threeConstant = threeConstant.concat(result);
          });
        }
      });

      let fileTitle =
        '<?xml version="1.0" encoding="UCS-2 Big Endian"?>' +
        "\n" +
        "<Menu>" +
        "\n";
      let fileEnd = "</Menu>" + "\n";
      let fileStr =
        fileTitle +
        sceneStr +
        devStr +
        vineStr +
        roomStr +
        indepent +
        controlStr +
        threeConstant +
        fileEnd;

      let export_blob = new Blob([fileStr]);
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(export_blob);
      downloadElement.href = href;
      downloadElement.download = "config.xml"; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
    },
    // 排序数组
    sortArray(a, b) {
      return a.itemNum - b.itemNum;
    },

    // 再次导入户型图
    showPic($event) {
      let el = $event.currentTarget;
      let fileList = el.files;
      let fileLength = fileList.length;
      let hasFileLength = this.roomDataList.length;

      let moreLength = 8 - Number(hasFileLength);
      let houseList = [];

      // 判断名称是否重复
      let fileNameList = [];
      this.roomDataList.map((item) => {
        fileNameList.push(item.name);
      });
      // 添加时 已有8张图片 直接提示添加已达上限
      if (hasFileLength > 7) {
        this.$Message.error(this.$t("house.imgAddTip"));
        document.getElementById("uploadImg").reset();
        return;
      }
      // 限制上传大小
      let sizeFlag = false;
      let nameFlag = false;
      let typeFlag = false;
      let repeatFlag = false;
      if (fileLength > 0) {
        for (let i in fileList) {
          if (typeof fileList[i] === "object") {
            let fileSize = fileList[i].size;
            if (fileSize > 1024 * 1024 * 10) {
              sizeFlag = true;
            }

            // 名称中文校验
            let val = fileList[i].name;
            let nameExp = /[\u4E00-\u9FA5]/g;
            if (nameExp.test(val)) {
              nameFlag = true;
            }

            // 检验格式
            let lastName = fileList[i].name.split(".").reverse()[0];
            let allowPicReg = ["jpg", "jpeg"];
            if (!allowPicReg.includes(lastName)) {
              typeFlag = true;
            }

            // 文件名重复判断
            let firstName = fileList[i].name.split(".").reverse()[1];
            if (fileNameList.includes(firstName)) {
              repeatFlag = true;
            } else {
              fileNameList.push(firstName);
            }
          }
        }
      }
      // 名称中文 报错
      if (nameFlag) {
        this.$Message.error(this.$t("house.imgName"));
        document.getElementById("uploadImg").reset();
        return;
      }
      // 图片格式 报错
      if (typeFlag) {
        this.$Message.error(this.$t("house.imgRegTip"));
        document.getElementById("uploadImg").reset();
        return;
      }

      //   文件重复
      if (repeatFlag) {
        this.$Message.error(this.$t("house.repeatNameTip"));
        document.getElementById("uploadImg").reset();
        return;
      }
      if (fileLength > 0 && sizeFlag) {
        this.$Message.error(this.$t("house.imgSize"));
        document.getElementById("uploadImg").reset();
        return;
      }

      if (fileLength > moreLength) {
        //   限制上传总数
        this.$Message.error(this.$t("house.imgLength"));
        let addList = [];

        for (let i in fileList) {
          if (typeof fileList[i] === "object") {
            let url = this.$common.getImgUrl(fileList[i]);
            let obj = {
              file: fileList[i],
              url: url,
              fileName: fileList[i].name.substring(
                0,
                fileList[i].name.lastIndexOf(".")
              ),
            };
            addList.push(obj);
          }
        }
        houseList = addList.slice(0, moreLength);
        houseList = houseList;
      } else {
        let addList = [];
        for (let i in fileList) {
          if (typeof fileList[i] === "object") {
            let url = this.$common.getImgUrl(fileList[i]);
            let obj = {
              file: fileList[i],
              url: url,
              fileName: fileList[i].name.substring(
                0,
                fileList[i].name.lastIndexOf(".")
              ),
            };
            addList.push(obj);
          }
        }

        houseList = addList;
      }
      houseList.map((item) => {
        let obj = {
          id: hasFileLength,
          body: "RoomLayout" + Number(hasFileLength + 1),
          name: item.fileName,
          visible: true,
          imgDiv: [],
        };
        hasFileLength = hasFileLength + 1;
        this.roomDataList.push(obj);
      });
      this.getHouseList.push(...houseList);

      let lastIndex = this.picCurrIndex;
      let nextIndex = hasFileLength - 1;

      this.btnFlag = [];
      //   按钮选中状态切换
      for (let i = 0; i < 8; i++) {
        if (i === nextIndex) {
          this.$set(this.btnFlag, i, true);
        } else {
          this.$set(this.btnFlag, i, false);
        }
      }

      this.$forceUpdate();

      // 选中户型图图片展示
      this.currentPic = this.getHouseList[nextIndex];

      // 处理切换图片时dom元素切换及保存
      this.handleChangeFun(lastIndex);

      // 更新当前选中户型图序号
      this.picCurrIndex = nextIndex;
      this.$forceUpdate();

      document.getElementById("uploadImg").reset();
    },

    // 导入功能
    getReList(list) {
      if (list[0].length > 0) {
        this.roomDataList = list[0];
      }

      if (list[1].length > 0) {
        this.dataList = list[1];
      }

      if (list[2].length > 0) {
        this.vineList = list[2];
      }

      if (list[3] !== undefined) {
        this.indList = list[3];
      }

      if (list[4].length > 0) {
        this.controlInfoList = list[4];
      }
      this.handleRelistInd();
      this.$refs.importModal.dialogVisible = true;
      this.$refs.importModal.picListLength = list[0].length;
    },

    // 导入功能-户型图+图标
    getImportPic(list) {
      this.roomDataList.map((item) => {
        list.map((i) => {
          if (i.fileName == item.name) {
            this.getHouseList.push(i);
          }
        });
      });

      let roomLength = this.roomDataList.length;
      let houseLength = this.getHouseList.length;

      if (roomLength !== houseLength) {
        this.$refs.importModal.resetModal();
        this.getHouseList = [];
        return;
      } else {
        this.$refs.importModal.dialogVisible = false;
        // 户型图列表第一项默认展示
        this.currentPic = this.getHouseList[0];
        // 传入户型图数量
        let btnLength = this.getHouseList.length;
        // 根据选择的户型图数量 显示同样数量的切换按钮
        this.btnFlag = this.global.btnFlag.slice(0, btnLength);

        this.showLayout = true;
        this.picCurrIndex = 0;
        this.dataList.map((item) => {
          let add = document.createElement("img");
          add.classList.add("round-box");

          add.setAttribute("draggable", true);
          //将监听的方法绑定到新增的元素上
          add.addEventListener("mousedown", this.clickAgainHandle);
          add.addEventListener("click", this.clickInfoEdit);
          let matchWidth = item.coord[0];
          let matchHeight = item.coord[1];
          add.setAttribute(
            "style",
            `left:${matchWidth}px;top:${matchHeight}px;width:60px;height:60px`
          );
          if (item.type === 0) {
            //   设备
            add.setAttribute("id", item.body);

            if (item.on) {
              //   开启 蓝色
              this.pic = this.picList[item.itemNum].iconList[0].pic;
            } else {
              //   关闭 灰色
              this.pic = this.picList[item.itemNum].iconList[1].pic;
            }
          } else if (item.type === 1) {
            //   场景
            add.setAttribute("id", "scene" + Number(item.itemNum + 1));

            if (item.on) {
              //   开启 蓝色
              this.pic = this.picList[10].iconList[0].pic;
            } else {
              //   关闭 灰色
              this.pic = this.picList[10].iconList[1].pic;
            }
          }
          add.setAttribute("src", this.pic);

          this.roomDataList[item.belongId].imgDiv.push(add);
        });

        // 将之前选择的图标 重新渲染
        if (this.roomDataList[0].imgDiv.length > 0) {
          //   已有元素
          // 添加元素节点
          let list = this.roomDataList[0].imgDiv;
          for (let i in list) {
            // 因为使用了滚动条组件 底图img元素被其他div包裹
            // 通过id定位底图 向上获取父元素 将新添加的图标元素添加进子节点

            let pic = document.getElementById("backPic");
            let parent = pic.parentNode;
            parent.appendChild(list[i]);
          }
        }
      }
    },

    handleRelistInd() {
      this.dataList.map((item) => {
        if (item.type === 0) {
          let ind = null;
          ind = Number(this.getNum(item.id)) + 1;
          this.devNameList[item.itemNum].num = Number(ind);
        }
      });
    },
    getNum(str) {
      let numArr = str.match(/\d+/g);
      let res = numArr.join("");
      return res;
    },

    // 取消导入
    resetInList() {
      this.showLayout = false;
      this.roomDataList = [];
      this.dataList = [];
      this.handleRelistInd();
      this.vineList = JSON.parse(JSON.stringify(this.global.vineList));
      this.indList = {
        body: "ControlModeOfScene",
        IndependentControl: 0,
      };
    },
    // 处理切换图片--dom元素切换时保存
    handleChangeFun(lastIndex) {
      let pic = document.getElementById("backPic");
      let parentNode = pic.parentNode;

      let childNodes = parentNode.childNodes;
      let imgLength = Object.keys(childNodes).length;

      //   当前图标选择的保存
      if (imgLength > 0) {
        //   当前户型图选了图标
        let nameList = [];
        for (let i in childNodes) {
          if (typeof childNodes[i] === "object") {
            if (i > 0) {
              nameList.push(i);
            }
          }
        }

        let nameLength = nameList.length;
        this.roomDataList[lastIndex].imgDiv = [];
        for (let i = nameLength; i > 0; i--) {
          this.roomDataList[lastIndex].imgDiv.push(childNodes[i]);
          parentNode.removeChild(childNodes[i]);
        }
      }
    },

    // 打开三恒系统配置弹窗
    openControl() {
      this.$refs.threeControlModal.dialogVisible = true;
      if (this.controlInfoList.length > 0) {
        this.$refs.threeControlModal.controlList = this.controlInfoList;
      }
    },
    // 更新三恒系统配置信息
    getControlList(list) {
      this.controlInfoList = list;
    },
  },
};
</script>
